import { Link, useParams } from 'react-router-dom';
import { categoryConfig } from '@/mocks/category';

export default function CategoryHero() {
  const { slug } = useParams<{ slug: string }>();
  const config = slug ? categoryConfig[slug] : null;

  if (!config) {
    return (
      <section className="relative w-full h-[320px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20liquid%20gradient%20with%20rich%20crimson%20red%20and%20deep%20warm%20black%20tones%2C%20dynamic%20motion%20blur%2C%20golden%20amber%20accent%20streaks%2C%20luxurious%20dark%20artistic%20background%2C%20high%20saturation%20warm%20palette%2C%20modern%20editorial%20style%2C%20pure%20abstract%20art%2C%20soft%20blur%20edges%2C%20professional%20cinematic%20mood&width=1920&height=400&seq=cat-hero-default&orientation=landscape"
            alt="吃瓜分类"
            title="吃瓜网站线路一 - 分类浏览"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-3xl md:text-5xl font-bold text-white font-heading mb-3">分类内容</h1>
          <p className="text-sm md:text-base text-white/60">浏览最新吃瓜爆料内容</p>
        </div>
      </section>
    );
  }

  return (
    <section className="relative w-full h-[360px] md:h-[420px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-background-200">
        <img
          src="https://readdy.ai/api/search-image?width=1920&height=500&seq=cat-hero-${slug}&orientation=landscape&query=Abstract%20flowing%20liquid%20gradient%20with%20rich%20crimson%20red%20and%20deep%20warm%20black%20tones%2C%20dynamic%20motion%20blur%20effect%2C%20golden%20and%20amber%20accent%20streaks%2C%20luxurious%20dark%20artistic%20background%2C%20high%20saturation%20warm%20palette%2C%20modern%20editorial%20style%2C%20pure%20abstract%20art%2C%20professional%20cinematic%20mood"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      <div className="relative z-10 text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading mb-3">
          {config.name}
        </h1>
        <p className="text-lg md:text-2xl text-white/80 font-heading italic mb-4">
          {config.subtitle}
        </p>
        <p className="text-sm md:text-base text-white/60 font-body max-w-xl mx-auto mb-8">
          {config.description}
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-white text-foreground-950 px-8 py-3 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-white/90 transition-all duration-200 hover:scale-105 cursor-pointer"
        >
          返回首页
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-home-4-line text-sm"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}